import { Component, EventEmitter, OnInit, AfterViewInit, ViewChild, ViewChildren, QueryList, ComponentFactoryResolver, Type } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart, Route } from '@angular/router';
import { MenuItem, ConfirmationService } from 'primeng/primeng';


//constants
import { Constants } from './constants/Constants';
import * as enums from './enums/index'
import * as comp from './components/index'
import * as ent from './entities/index'
import * as serv from './services/index'
import * as util from './util/index'
import * as filters from './filters/index'
import { BaseRequestComponent } from './baseclasses/BaseRequest.component';
//directives
import { UCDirective } from './directives/UCDirective';
import { MessageHandlerComponent } from './components/index';
import { AppSettingEnum } from './enums/index';
import { filter } from 'rxjs/operators';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Logger, CryptoUtils, AuthenticationParameters } from 'msal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'my-app',
  templateUrl: './app.component.html'
})
export class AppComponent {
    name = 'Activity Requests';
    returnUrl: string = 'container';


    displayConfirmNavigateToExternalURL: boolean;
    activeIndex: number = 0;
    tabs: any[] = [];
    ucItems: ent.UCItem[];
    ucItem: ent.UCItem;
    ucItemToAdd: ent.UCItem;
    userInfo: ent.UserInfo;
    isUserLoggedIn: boolean;
    isIframe: boolean = false;
    canSubmitFullServicePricingUpdates: boolean;
    canReviewFullServicePricingUpdates: boolean;
    canSubmitVisitPlanUpdates: boolean;
    canSubmitZRPartnerUpdates: boolean;
    canSubmitDSDPlanningRequests: boolean;
    canSubmitMICRChangesRequests: boolean;
    canCompleteVisitPlanUpdates: boolean;
    canCompleteZRPartnerUpdates: boolean;
    canCompleteDSDPlanningRequests: boolean;
    canMaintainEmployees: boolean;
    canMaintainActivityReasons: boolean;
    canMaintainEquipmentTemplateRules: boolean;
    canMaintainDomainData: boolean;
    canMaintainStandardDomainData: boolean = false;
    canMaintainKeyAccounts: boolean;
    canMaintainModels: boolean;
    canMaintainModelGroups: boolean;
    canMaintainPrimaryGroupOverrides: boolean;
    canMaintainSalesOffices: boolean;
    canMaintainVendPackages: boolean;
    canMaintainVendSizeFlavorXrefs: boolean;
    canMaintainContactValidations: boolean;
    canMaintainUserMessages: boolean;
    canPerformMassUpdates: boolean;
    canPerformSuperUserActions: boolean;
    dashboardsCreated: number;
    hideMenu: boolean;
    canViewLogMessages: boolean;
    canMaintainDSDFreeze: boolean;
    canMaintainSalesOfficeRequestTypes: boolean;
    canViewImportAudits: boolean;
    canViewAdminMenuItem: boolean;
    isDSDPlanningFreezeActive: boolean;
    domainTables: ent.Table[];
    authenticating: boolean;
    salesOfficeRequestTypes: ent.SalesOfficeRequestType[] = [];


  @ViewChildren(UCDirective) ucHosts: QueryList<UCDirective>;
  @ViewChild(UCDirective) ucHost: UCDirective;
  @ViewChild(MessageHandlerComponent) messageHandlerComponent: comp.MessageHandlerComponent;

  public menuItems: MenuItem[];
  hash: string;

  private loginSuccessSubscription: Subscription;
  private myInteractionRequiredAuthErrorSubscription: Subscription;

  constructor(
    private authenticationService: serv.AuthenticationService,
    private employeeService: serv.EmployeeService,
    private domainDataService: serv.DomainDataService,
    private adminService: serv.AdminService,
    private confirmationService: ConfirmationService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private msalService: MsalService,
    private broadcastService: BroadcastService
  ) {
      this.dashboardsCreated = 0;
      this.hideMenu = true;


  }


  subscriptions: Subscription[] = [];
  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.checkoutAccount();
    

    this.loginSuccessSubscription = this.broadcastService.subscribe('msal:loginSuccess', () => {
      console.info('Login success ');
      this.checkoutAccount();

      
    });

    this.broadcastService.subscribe('msal:MyInteractionRequiredAuthError', (payload) => {
      const scopes = this.msalService.getScopesForEndpoint(payload.req.url);
      console.log('msal:MyInteractionRequiredAuthError', JSON.stringify(payload));
      this.msalService.acquireTokenRedirect({scopes});
    });
    


    this.msalService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error('Redirect Error: ', authError.errorMessage);
        return;
      }

      console.log('Redirect Success: ', response);
    });

    this.msalService.setLogger(new Logger((logLevel, message, piiEnabled) => {
      console.log('MSAL Logging: ', message);
      
      if (message.includes("Token renewal operation failed due to timeout")) {
        window.location.reload();
      };
      
    }, {
      correlationId: CryptoUtils.createNewGuid(),
      piiLoggingEnabled: false
    }));
  }

  checkoutAccount() {
    
    var account = this.msalService.getAccount();
    this.isUserLoggedIn = !!account;
    if (this.isUserLoggedIn) {
      if (!this.authenticating) {
        this.authenticating = true;
        this.authenticateUser();
      }
    }
    
  }
  
  

 ngOnDestroy() {
    this.broadcastService.getMSALSubject().next(1);
    if(this.loginSuccessSubscription) {
      this.loginSuccessSubscription.unsubscribe();
    }
    if(this.myInteractionRequiredAuthErrorSubscription) {
      this.myInteractionRequiredAuthErrorSubscription.unsubscribe();
    }
  }

 

  

  

  login() {
    this.msalService.loginRedirect();

    //const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

    // if (isIE) {
    //   this.msalService.loginRedirect();
    // } else {
    //   this.msalService.loginPopup();
    // }
    
  }

  logout() {
    this.msalService.logout();
  }

  // isLoggedIn() {
  //   return this.msalService.getAccount() != null;
  // }

  ngAfterViewInit() {
    this.ucHosts.changes.subscribe(() => { this.ucHostsChanged() });
  }  
  
  authenticateUser(): void {
    this.authenticationService
      .authenticateUser()
      .subscribe(x => this.finalizeLogin(x));
  }

  finalizeLogin(authenticationResult: ent.AuthenticationResult): void {
    if (authenticationResult.Success) {

      this.storeUserInfo(authenticationResult);

      this.handleAppSecurity();

      this.cacheReferenceData();
    }
    else {
     this.handleActivationRequest(authenticationResult);
    }

  }

  storeUserInfo(authenticationResult: ent.AuthenticationResult) {
    // store username in local storage to keep user logged in between page refreshes
    localStorage.setItem('currentUser', JSON.stringify({
      salesOffice: authenticationResult.Employee.SalesOffice,
      employee: authenticationResult.Employee,
      features: authenticationResult.Employee.Features,
      appSettings: authenticationResult.AppSettings
    }));
  }

  cacheReferenceData() {

    this.domainDataService.getVendSizeFlavorXrefs({ IncludeInactive: false }).subscribe(x => {
      localStorage.setItem('vendSizeFlavorXrefs', JSON.stringify({ x }));

      var salesOfficeFilter: filters.SalesOfficeFilter = { IncludeInactive: false };
      this.domainDataService.getSalesOffices(salesOfficeFilter).subscribe(x => {
        localStorage.setItem('salesOffices', JSON.stringify({ x }));

        this.domainDataService.getTables().subscribe(x => {
          this.domainTables = x;
          for (var item of x) {
            var isVisible = util.SecurityUtil.CanAccessFeature(this.userInfo, item.FeatureID);
            if (isVisible == true) {
              this.canMaintainStandardDomainData = true;
            }
          }
        });
      });
    });
  }

  handleActivationRequest(authenticationResult: ent.AuthenticationResult) {
    if (authenticationResult.EmployeeActivationRequests && authenticationResult.EmployeeActivationRequests.length > 0) {
      this.confirmationService.confirm({
        message: "Your credentials are valid in Active Directory, but your employee information could not be found in the ARIES database, and will need to be added. An Employee Activation Request to add your employee information has already been sent. You will be notified when it is complete.",
        key: "cd4",
        accept: () => {
          this.doLogout();
        },
      });
    }
    else {
      this.confirmationService.confirm({
        message: "Your credentials are valid in Active Directory, but your employee information could not be found in the ARIES database, and will need to be added. For this to happen, a request will be emailed to the Employee Activation team. Continue?",
        key: "cd3",
        accept: () => {
          this.createEmployeeActivationRequest(authenticationResult.Location);
        },
        reject: () => {
          this.doLogout();
        }
      })
    }
  }

  handleAppSecurity() {

    this.userInfo = this.authenticationService.getUserInfo();

    this.domainDataService.getAppSettings().subscribe(x => {
      var filter: filters.SalesOfficeRequestTypeFilter = {SalesOfficeID: this.userInfo.SalesOffice.ID, GetDataRequest: {Employee: this.userInfo.Employee}};
      this.adminService.getSalesOfficeRequestTypes(filter).subscribe(y=> {
          this.salesOfficeRequestTypes = y;
          var dsdFreezeAppSetting = x.filter(y => y.ID == AppSettingEnum.DSDPlanningFreezeActive)[0];
          this.isDSDPlanningFreezeActive = dsdFreezeAppSetting.SettingValue == "true" ? true : false;

          this.canMaintainEquipmentTemplateRules = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainEquipmentTemplateRules);
          this.canMaintainActivityReasons = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainActivityReasons);
          this.canMaintainEmployees = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainEmployees);
          this.canMaintainKeyAccounts = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainKeyAccounts);
          this.canMaintainModels = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainModels);
          this.canMaintainModelGroups = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainModelGroups);
          this.canMaintainPrimaryGroupOverrides = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainPrimaryGroupOverrides);
          this.canMaintainSalesOffices = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainSalesOffices);
          this.canMaintainVendPackages = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainVendPackages);
          this.canMaintainContactValidations = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainContactValidations);
          this.canMaintainVendSizeFlavorXrefs = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainVendSizeFlavorXrefs);
          this.canViewLogMessages = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.ViewLogMessages);
          this.canViewImportAudits = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.ViewImportAudits);
          this.canSubmitFullServicePricingUpdates = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.SubmitFullServicePricingUpdates);
          this.canReviewFullServicePricingUpdates = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.ReviewFullServicePricingUpdates);
          this.canSubmitVisitPlanUpdates = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.SubmitVisitPlanUpdates) && !this.isDSDPlanningFreezeActive;
          this.canSubmitZRPartnerUpdates = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.SubmitZRPartnerUpdates) && !this.isDSDPlanningFreezeActive;
          this.canSubmitMICRChangesRequests = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.SubmitMICRChanges);
          this.canCompleteVisitPlanUpdates = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.CompleteVisitPlanUpdates);
          this.canCompleteZRPartnerUpdates = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.CompleteZRPartnerUpdates);
          this.canPerformSuperUserActions = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.SuperUser);


          this.canMaintainDomainData = this.canMaintainKeyAccounts || this.canMaintainModels || this.canMaintainModelGroups || this.canMaintainVendSizeFlavorXrefs || this.canMaintainPrimaryGroupOverrides || this.canMaintainSalesOffices;

          this.canSubmitDSDPlanningRequests = this.canSubmitVisitPlanUpdates || this.canSubmitZRPartnerUpdates;

          this.canCompleteDSDPlanningRequests = this.canCompleteVisitPlanUpdates || this.canCompleteZRPartnerUpdates;

          this.canMaintainUserMessages = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainUserMessages);
          this.canPerformMassUpdates = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.PerformMassUpdates);
          this.canMaintainDSDFreeze = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainDSDFreeze);
          this.canMaintainSalesOfficeRequestTypes = util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.MaintainSalesOfficeRequestTypes);

          this.canViewAdminMenuItem = this.canViewLogMessages || this.canMaintainUserMessages || this.canPerformMassUpdates;

          this.loadDomainMenuItems();

          this.createDashboardTab();
          this.hideMenu = false;
      });
      

    });
  }

  doLogout() {
    this.logout();
  }

  createEmployeeActivationRequest(location: string) {
    var request: ent.EmployeeActivationRequest = { StatusID: enums.EmployeeActivationRequestStatusEnum.Open, Location: location };

    this.employeeService.saveEmployeeActivationRequest(request).subscribe(x => {
      this.messageHandlerComponent.handleResponse(x);
      this.doLogout();
    })
  }

  loadDomainMenuItems() {
    var domainMenuItems: MenuItem[] = [];

    this.domainDataService.getTables().subscribe(x => {
      this.domainTables = x;
      for (var item of x) {
        var isVisible = util.SecurityUtil.CanAccessFeature(this.userInfo, item.FeatureID);
        if (isVisible == true) {
          this.canMaintainStandardDomainData = true;
        }
        var menuItem: MenuItem = {
          label: item.FriendlyName,
          visible: isVisible,
          icon: 'fa-dot-circle-o',
          command: (event: any) => { this.addTab(event, comp.DomainRecordGridComponent) }
        };
        domainMenuItems.push(menuItem);
      }
      this.createMenus(domainMenuItems);
    }
    );
  }

  isSalesOfficeRequestTypeEnabled(requestTypeID: number) : boolean {
    var val = util.SecurityUtil.IsSalesOfficeRequestTypeEnabled(this.userInfo, requestTypeID, this.salesOfficeRequestTypes);
    return val;
  }

  createMenus(domainMenuItems: MenuItem[]) {

    this.menuItems = [
      {
        label: 'Upload',
        items: [
          { label: 'Upload Completion Info', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.UploadCompletionInfoComponent) } },
        ]
      },
      {
        label: 'Exports', visible: this.canPerformSuperUserActions,
        items: [
          { label: 'Export Fields', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ExportFieldGridComponent) } },
          { label: 'File Fields', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.FileFieldGridComponent) } },
          { label: 'Export Files', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ExportFileGridComponent) } },
          { label: 'Request Type Files', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.RequestTypeFileComponent) } },
          //{ label: 'Request Export Property Values', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.RequestExportPropertyValueGridComponent) } },
          { label: 'Request Export File Data', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.RequestExportFileDataGridComponent) } },
          { label: 'Request Types', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.RequestTypeGridComponent) } }
        ]
      },
      {
        label: 'Super', visible: this.userInfo.Employee.IsSuper,
        items: [
          { label: 'Validations', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ValidationGridComponent) } },
          { label: 'Equipment Search', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.EquipmentGridComponent) } },
          { label: 'Convert Equipment Requests', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ConvertEquipmentRequestsComponent) } }
        ]
      },
      {
        label: 'Accounts Receivable',
        items: [
          //   {label: 'Create Accounts Receivable Update', icon:'fa-dot-circle-o', command: (event: any) => {this.addTab(event, comp.CreateAccountsReceivableUpdateRequest)}},
          { label: 'Create Invoice/Statement Copies', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.InvoiceStatementCopies),  icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateInvoiceStatementCopiesRequestComponent) } },
          { label: 'Create Collections Setup', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.CollectionsSetup), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateCollectionsSetupRequestComponent) } },
          // 2023-12-05 AR-951: Uncomment the following line when we are ready to go live with AR Corrections
          // { label: 'Create AR Corrections', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateBillingDiscrepancyRequestComponent) } },
          { label: 'Create MICR Changes', visible: this.canSubmitMICRChangesRequests && this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.MICRChanges), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateMICRChangesRequestComponent) } }
        ]
      },
      {
        label: 'Customer',
        items: [
          { label: 'Create Sold To Customer', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.SoldToCustomer), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateSoldToCustomerRequestComponent) } },
          { label: 'Create Full Service Customer', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.FullServiceCustomer), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateFullServiceCustomerRequestComponent) } },
          { label: 'Create Payer', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.Payer), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreatePayerRequestComponent) } },
          { label: 'Create Payer Linkages', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.PayerLinkages), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreatePayerLinkagesRequestComponent) } },
          { label: 'Create Equipment Only', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.EquipmentOnlyCustomer), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateEquipmentOnlyRequestComponent) } },
          { label: 'Create Driver', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.Driver), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateDriverRequestComponent) } },
          { label: 'Create Maintain Customer', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.MaintainCustomer), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateMaintainCustomerRequestComponent) } },
          { label: 'Create Suppress Customer', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.SuppressCustomer), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateSuppressCustomerRequestComponent) } },
          { label: 'Create Unsuppress Customer', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.UnsuppressCustomer), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateUnsuppressCustomerRequestComponent) } },
          { label: 'Create Update Pricing', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.UpdatePricing), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateUpdatePricingRequestComponent) } },
          { label: 'Create or Update Partner Functions', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.PartnerFunctions), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreatePartnerFunctionsRequestComponent) } },
          { label: 'Create Miscellaneous', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.Miscellaneous), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateMiscellaneousRequestComponent) } }
        ]
      },
      {
        label: 'Equipment',
        items: [
          { label: 'Create Equipment Install', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.EquipmentInstall), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateEquipmentInstallRequestComponent) } },
          { label: 'Create Equipment Remove', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.EquipmentRemove), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateEquipmentRemoveRequestComponent) } },
          { label: 'Create Equipment Swap', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.EquipmentSwap), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateEquipmentSwapRequestComponent) } },
          { label: 'Create Equipment Move', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.EquipmentMove), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateEquipmentMoveRequestComponent) } },
          { label: 'Create Equipment Survey', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.EquipmentSurvey), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateEquipmentSurveyRequestComponent) } },
          { label: 'Create Equipment Maintenance', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.EquipmentMaintenance), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateEquipmentMaintenanceRequestComponent) } },
          { label: 'Create Paperwork Only Move', visible: this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.PaperworkOnlyMove), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreatePaperworkOnlyMoveRequestComponent) } }
        ]

      },
      {
        label: 'DSD Planning', visible: this.canSubmitDSDPlanningRequests || this.canCompleteDSDPlanningRequests,
        items: [
          { label: 'Create Visit Plan Update', visible: this.canSubmitVisitPlanUpdates && this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.VisitPlanUpdate), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateVisitPlanUpdateRequestComponent) } },
          { label: 'Create ZR Partner Update', visible: this.canSubmitZRPartnerUpdates && this.isSalesOfficeRequestTypeEnabled(enums.RequestTypeEnum.ZRPartnerUpdate), icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateZRPartnerUpdateRequestComponent) } },
          { label: 'Assigned Requests', visible: this.canCompleteDSDPlanningRequests, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.AssignedRequestsComponent) } }
        ]
      },
      {
        label: 'Full Service Pricing', visible: this.canSubmitFullServicePricingUpdates || this.canReviewFullServicePricingUpdates,
        items: [
          { label: 'Package Configs', visible: this.canReviewFullServicePricingUpdates, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.FullServicePackageConfigGridComponent) } },
          { label: 'Existing FSP Requests', visible: this.canSubmitFullServicePricingUpdates || this.canReviewFullServicePricingUpdates, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.FullServicePricingRequestsComponent) } },
          { label: 'Create FSP Update', visible: this.canSubmitFullServicePricingUpdates, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.CreateFullServicePricingRequestComponent) } }
        ]
      },
      {
        label: 'Requests',
        items: [
          { label: 'Existing Requests', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.RequestsGridComponent) } },
          { label: 'Request History', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.RequestHistoryComponent) } }
        ]
      },
      {
        label: 'Domain Data (Standard)', visible: this.canMaintainStandardDomainData,
        items: domainMenuItems
      },
      {
        label: 'Domain Data (Custom)', visible: this.canMaintainDomainData,
        items: [

          { label: 'Activity Reasons', visible: this.canMaintainActivityReasons, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ActivityReasonGridComponent) } },
          { label: 'Equipment Template Rules', visible: this.canMaintainEquipmentTemplateRules, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.EquipmentTemplateRuleGridComponent) } },
          { label: 'Primary Groups', visible: this.canMaintainKeyAccounts, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.KeyAccountGridComponent) } },
          { label: 'Models', visible: this.canMaintainModels, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ModelGridComponent) } },
          { label: 'Model Groups', visible: this.canMaintainModelGroups, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ModelGroupGridComponent) } },
          { label: 'Primary Group Overrides', visible: this.canMaintainPrimaryGroupOverrides, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.PrimaryGroupOverrideGridComponent) } },
          { label: 'Sales Offices', visible: this.canMaintainSalesOffices, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.SalesOfficeGridComponent) } },
          { label: 'Vend Size Flavor Xrefs', visible: this.canMaintainVendSizeFlavorXrefs, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.VendSizeFlavorXrefGridComponent) } },
          { label: 'Contact Validations', visible: this.canMaintainContactValidations, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ContactValidationGridComponent) } }
        ]
      },
      {
        label: 'Security',
        items: [{ label: 'Employees', visible: this.canMaintainEmployees, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.EmployeesGridComponent) } },
        { label: 'Sales Office Approvers', visible: this.canMaintainEmployees, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.SalesOfficeApproverGridComponent) } },
        { label: 'Application Info', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ApplicationInfoComponent) } },
        { label: 'Change Password', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ChangePasswordComponent) } },
        { label: 'Dashboard', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.DashboardComponent) } },
        //{ label: 'Logout', icon: 'fa-dot-circle-o', routerLink: "/logout" }]
        { label: 'Logout', icon: 'fa-dot-circle-o', command: (event: any) => {this.doLogout()} }
      ]
      },
      {
        label: 'Admin', visible: this.canViewAdminMenuItem,
        items: [
          { label: 'Import Audits', visible: this.canViewImportAudits, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.ImportAuditGridComponent) } },
          { label: 'Log Messages', visible: this.canViewLogMessages, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.LogMessagesGridComponent) } },
          { label: 'User Message', visible: this.canMaintainUserMessages, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.UserMessageEditComponent) } },
          { label: 'Mass Updates', visible: this.canPerformMassUpdates, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.MassUpdatesComponent) } },
          { label: 'Employee Activation Requests', icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.EmployeeActivationRequestsGridComponent) } },
          { label: 'DSD Planning Freeze', visible: this.canMaintainDSDFreeze, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.MaintainDSDFreezeComponent) } },
          { label: 'Sales Office Request Types', visible: this.canMaintainSalesOfficeRequestTypes, icon: 'fa-dot-circle-o', command: (event: any) => { this.addTab(event, comp.MaintainSalesOfficeRequestTypes) } }
        ]
      }

        ]
    }


  createDashboardTab() {

    if (this.dashboardsCreated == 0) {
      var ucItem: ent.UCItem = new ent.UCItem(comp.DashboardComponent, { name: "Dashboard" });
      this.ucItemToAdd = ucItem;
      var tab = { Header: ucItem.data.name };
      this.tabs.push(tab);
      this.dashboardsCreated++;
    }

  }

  ucHostsChanged() {
    if (this.ucItemToAdd != null) {
      var tabIndex = this.ucHosts.toArray().length - 1;

      this.loadComponent(this.ucItemToAdd, tabIndex);
      this.activeIndex = tabIndex;
      //console.debug("ucHostsChanged: tabIndex=" + tabIndex);
      this.ucItemToAdd = null;
    }
  }

  loadComponent(ucItem: ent.UCItem, tabIndex: number) {

    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(ucItem.component);

    this.ucHost = this.ucHosts.toArray()[tabIndex];
    if (this.ucHost != null) {
      let viewContainerRef = this.ucHost.viewContainerRef;
      viewContainerRef.clear();

      let componentRef = viewContainerRef.createComponent(componentFactory);

      if (componentRef.componentType === comp.DomainRecordGridComponent) {
        var domainRecordGridComponent = componentRef.instance as comp.DomainRecordGridComponent;
        domainRecordGridComponent.tableName = ucItem.data.domainTable.Name;
        domainRecordGridComponent.recordEditComponent.tableName = ucItem.data.domainTable.FriendlyName;
      }

      else if (componentRef.componentType.prototype instanceof BaseRequestComponent) {
        var requestComponent = componentRef.instance as BaseRequestComponent;
        requestComponent.requestID = ucItem.data.data;
      }

      else if (componentRef.componentType === comp.RequestsGridComponent) {
        var grid = componentRef.instance as comp.RequestsGridComponent;
        grid.loadMultiSelectsOnInit = true;
        grid.openRequestTab.subscribe((x: ent.Request) => this.handleOpenRequestTab(x));
      }
      else if (componentRef.componentType === comp.DashboardComponent) {
        var dashboard = componentRef.instance as comp.DashboardComponent;
        dashboard.requestsGridComponent.openRequestTab.subscribe((x: ent.Request) => this.handleOpenRequestTab(x));
      }
      else if (componentRef.componentType === comp.AssignedRequestsComponent) {
        var assignedRequests = componentRef.instance as comp.AssignedRequestsComponent;
        assignedRequests.requestsGridComponent.openRequestTab.subscribe((x: ent.Request) => this.handleOpenRequestTab(x));
      }
      else if (componentRef.componentType === comp.FullServicePricingRequestsComponent) {
        var fspRequests = componentRef.instance as comp.FullServicePricingRequestsComponent;
        fspRequests.requestsGridComponent.openRequestTab.subscribe((x: ent.Request) => this.handleOpenRequestTab(x));
      }

    }

  }

  handleOpenRequestTab(request: ent.Request) {
    //this.addTab(null, CreateSoldToCustomerRequestComponent);
    var type: Type<any>;
    var name: string;

    switch (request.RequestTypeID) {
      case enums.RequestTypeEnum.Driver:
        type = comp.CreateDriverRequestComponent;
        name = "Driver";
        break;
      case enums.RequestTypeEnum.SoldToCustomer:
        type = comp.CreateSoldToCustomerRequestComponent;
        name = "Sold To Customer";
        break;
      case enums.RequestTypeEnum.SuppressCustomer:
        type = comp.CreateSuppressCustomerRequestComponent;
        name = "Suppress Customer";
        break;
      case enums.RequestTypeEnum.UnsuppressCustomer:
        type = comp.CreateUnsuppressCustomerRequestComponent;
        name = "Unsuppress Customer";
        break;
      case enums.RequestTypeEnum.UpdatePricing:
        type = comp.CreateUpdatePricingRequestComponent;
        name = "Update Pricing";
        break;
      case enums.RequestTypeEnum.Miscellaneous:
        type = comp.CreateMiscellaneousRequestComponent;
        name = "Miscellaneous";
        break;
      case enums.RequestTypeEnum.FullServiceCustomer:
        type = comp.CreateFullServiceCustomerRequestComponent;
        name = "Full Service Customer";
        break;
      case enums.RequestTypeEnum.PartnerFunctions:
        type = comp.CreatePartnerFunctionsRequestComponent;
        name = "Partner Functions";
        break;
      case enums.RequestTypeEnum.Payer:
        type = comp.CreatePayerRequestComponent;
        name = "Payer";
        break;
      case enums.RequestTypeEnum.PayerLinkages:
        type = comp.CreatePayerLinkagesRequestComponent;
        name = "Payer Linkages";
        break;
      case enums.RequestTypeEnum.EquipmentOnlyCustomer:
        type = comp.CreateEquipmentOnlyRequestComponent;
        name = "Equipment Only";
        break;
      case enums.RequestTypeEnum.MaintainCustomer:
        type = comp.CreateMaintainCustomerRequestComponent;
        name = "Maintain Customer";
        break;
      case enums.RequestTypeEnum.EquipmentInstall:
        type = comp.CreateEquipmentInstallRequestComponent;
        name = "Equipment Install";
        break;
      case enums.RequestTypeEnum.EquipmentRemove:
        type = comp.CreateEquipmentRemoveRequestComponent;
        name = "Equipment Remove";
        break;
      case enums.RequestTypeEnum.EquipmentSwap:
        type = comp.CreateEquipmentSwapRequestComponent;
        name = "Equipment Swap";
        break;
      case enums.RequestTypeEnum.EquipmentMove:
        type = comp.CreateEquipmentMoveRequestComponent;
        name = "Equipment Move";
        break;
      case enums.RequestTypeEnum.EquipmentSurvey:
        type = comp.CreateEquipmentSurveyRequestComponent;
        name = "Equipment Survey";
        break;
      case enums.RequestTypeEnum.EquipmentMaintenance:
        type = comp.CreateEquipmentMaintenanceRequestComponent;
        name = "Equipment Maintenance";
        break;
      case enums.RequestTypeEnum.PaperworkOnlyMove:
        type = comp.CreatePaperworkOnlyMoveRequestComponent;
        name = "Paperwork Only Move";
        break;
      case enums.RequestTypeEnum.VisitPlanUpdate:
        type = comp.CreateVisitPlanUpdateRequestComponent;
        name = "Visit Plan Update";
        break;
      case enums.RequestTypeEnum.ZRPartnerUpdate:
        type = comp.CreateZRPartnerUpdateRequestComponent;
        name = "ZR Partner Update";
        break;
      case enums.RequestTypeEnum.FullServicePricing:
        type = comp.CreateFullServicePricingRequestComponent;
        name = "FSP Update";
        break;
      case enums.RequestTypeEnum.AccountsReceivableUpdate:
        type = comp.CreateAccountsReceivableUpdateRequest;
        name = "Accounts Receivable Update";
        break;
      case enums.RequestTypeEnum.InvoiceStatementCopies:
        type = comp.CreateInvoiceStatementCopiesRequestComponent;
        name = "Invoice/Statement Copies";
        break;
      case enums.RequestTypeEnum.CollectionsSetup:
        type = comp.CreateCollectionsSetupRequestComponent;
        name = "Collections Setup";
        break;
      case enums.RequestTypeEnum.BillingDiscrepancy:
        type = comp.CreateBillingDiscrepancyRequestComponent;
        name = "AR Corrections";
        break;
      case enums.RequestTypeEnum.MICRChanges:
        type = comp.CreateMICRChangesRequestComponent;
        name = "MICR Changes";
        break;
      default:
        break;
    }


    var ucItem: ent.UCItem = new ent.UCItem(type, { name: name + ": " + request.ID, data: request.ID });
    this.ucItemToAdd = ucItem;
    var tab = { Header: ucItem.data.name };
    this.tabs.push(tab);
  }

  getInfoForTabToOpen(request: ent.Request, name: string, type: Type<any>) {

  }

  handleTabClose(event: any) {
    var idx = event.index;
    //console.debug("handleTabClose: event.index=" + event.index);
    this.tabs.splice(idx, 1);
    if (idx != 0) {
      this.activeIndex = idx - 1;
    }
    else {
      this.activeIndex = 0;
    }


  }

  handleTabChange(event: any) {
    this.activeIndex = event.index;
  }

  addTab(event: any, type: Type<any>) {
    var ucItem: ent.UCItem = new ent.UCItem(type, { name: event.item.label })


    var domainTable = this.domainTables.filter(x => x.FriendlyName == event.item.label)[0];
    if (domainTable != undefined) {
      ucItem.data.domainTable = domainTable;
    }

    this.ucItemToAdd = ucItem;
    var tab = { Header: ucItem.data.name };
    this.tabs.push(tab);
  }

  onHideConfirmNavigateToExternalURLDialog(event: any) {

  }

  onNavigateToExternalURLCancel(event: any) {
    this.displayConfirmNavigateToExternalURL = false;
  }

  onNavigateToExternalURLYes(event: any) {
    this.displayConfirmNavigateToExternalURL = false;
    window.open(Constants._PAPERWORK_ONLY_MOVE_EXTERNAL_URL, "_blank")
  }
}

